/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import TextField from '@material-ui/core/TextField';

import styles from './styles.module.scss';

import { setShippingAddress } from '../../../redux/actions/shippingActions';

import apiShippingCMS from '../../../api/Shipping';
import ApiShipping from '../../../api/Shipping/shippingApiFL';
import ApiAddress from '../../../api/Address';
import ApiBilling from '../../../api/Billing/billingFL';
import ValidateEmail from '../../../api/ValidateEmail';

import TextInput from '../../Input/Text';
import SuburbSelector from '../../Input/Selector/suburbSelector';
import TelSelector from '../../Input/Selector/telSelector';
import Selector from '../../Input/Selector/RandomSelector';
import Checkbox from '../../Input/Checkbox';
import { ReactComponent as Checked } from '../../../assets/icons/icon-radio-checked.svg';
import { ReactComponent as Unchecked } from '../../../assets/icons/icon-radio-unchecked.svg';

import Config, { spanish } from '../../../config/config';
import {
  textChars,
  alphanumericChars,
  numberChars,
  emailChars,
} from '../../../utils/format/character_restriction';

const Radio = ({
  name,
  value,
  checked,
  contentClass,
  onClick,
  onChange,
  children,
  type,
}) => (
  <div className={styles.radio}>
    <label onClick={onClick}>
      <input
        type={type || 'radio'}
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
      />
      <Checked />
      <Unchecked />
      <div className={contentClass}>{children}</div>
    </label>
  </div>
);

const ModalEmail = ({
  open,
  handleClose,
  email,
  onChangeCode,
  onCheckCode,
  error,
}) => (
  <div>
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={styles.modal}
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <div className={styles.paper}>
          <h2 id="transition-modal-title">Por favor confirma tu email</h2>
          <div id="transition-modal-description" className={styles.modalBody}>
            <div className={styles.textCorreo}>
              <p>Hemos enviado un código de verificación al correo:</p>
              <span>{email}</span>
            </div>
            <div className={styles.codeInput}>
              <TextField
                id="emailCode"
                label="Código de verificación"
                variant="outlined"
                onChange={onChangeCode}
              />
            </div>
            {error ? <p className={styles.error}>{error}</p> : ''}
            <div className={styles.buttons}>
              <button
                onClick={handleClose}
                type="button"
                className="btn btn-white"
              >
                REGRESAR
              </button>
              <button
                onClick={onCheckCode}
                type="button"
                className="btn btn-yellow "
              >
                CONFIRMAR
              </button>
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  </div>
);

const AddressForm = ({
  content,
  addressFormChangeHandler,
  suburbOptions,
  cityValue,
  stateValue,
  userAddressInfo,
}) => {
  const {
    PersonalInfoSpanish,
    PersonalInfoEnglish,
    ShippingInfoSpanish,
    ShippingInfoEnglish,
  } = content;
  const hasSuburbOptions = suburbOptions.length > 0;
  let cityPlaceholder = cityValue === '' && spanish ? 'Ciudad*' : 'City*';
  cityPlaceholder = cityValue !== '' ? cityValue : '';
  let statePlaceholder = stateValue === '' && spanish ? 'Estado*' : 'State*';
  statePlaceholder = stateValue !== '' ? stateValue : '';
  const hasPersonalPhoneType = userAddressInfo?.personalPhoneType;
  const hasShippingPhoneType = userAddressInfo?.shippingPhoneType;
  let personalTelSelection = '';
  let shippingTelSelection = '';
  if (hasPersonalPhoneType) {
    personalTelSelection =
      userAddressInfo.personalPhoneType === 1 ? 'móvil' : 'fijo';
  }

  if (hasShippingPhoneType) {
    shippingTelSelection =
      userAddressInfo.shippingPhoneType === 1 ? 'móvil' : 'fijo';
  }

  return (
    <>
      <div className={styles.fieldset}>
        <h4>{spanish ? PersonalInfoSpanish : PersonalInfoEnglish}</h4>
        <div className={styles.field}>
          <TextInput
            id="personalName"
            type="text"
            title={spanish ? 'Nombres*' : 'Name*'}
            value={userAddressInfo ? userAddressInfo.personalName : ''}
            onChange={addressFormChangeHandler}
            onKeyPress={textChars}
            required
          />
        </div>
        {/* <div className={styles.field}>
          <TextInput
            id="personalMiddleName"
            type="text"
            title={spanish ? 'Segundo nombre' : 'Second name'}
            value={
              userAddressInfo?.personalMiddleName
                ? userAddressInfo.personalMiddleName
                : ''
            }
            placeholder={spanish ? 'opcional' : 'optional'}
            onChange={addressFormChangeHandler}
            onKeyPress={textChars}
          />
          </div> */}
        <div className={styles.field}>
          <TextInput
            id="personalLastName"
            type="text"
            title={spanish ? 'Apellido*' : 'Last name*'}
            value={userAddressInfo ? userAddressInfo.personalLastName : ''}
            onChange={addressFormChangeHandler}
            onKeyPress={textChars}
            required
          />
        </div>
        <div className={styles.field}>
          <TextInput
            id="personalEmail"
            type="email"
            title={spanish ? 'Correo electrónico*' : 'Email*'}
            value={userAddressInfo ? userAddressInfo.personalEmail : ''}
            onChange={addressFormChangeHandler}
            onKeyPress={emailChars}
            required
          />
        </div>
        <div className={styles.fieldPhone}>
          {/* <p>{spanish ? 'Número telefónico*' : 'Phone number*'}</p> */}
          <div className={styles.hidde}>
            <TelSelector
              id="personalPhoneType"
              title={spanish ? 'Tipo*' : 'Type*'}
              value={personalTelSelection || 'móvil'}
              placeholder={spanish ? 'Seleccionar' : 'Select'}
              options={spanish ? ['móvil', 'fijo'] : ['mobile', 'home']}
              onChange={addressFormChangeHandler}
              required
            />
          </div>
          <div className={styles.fieldPhoneText}>
            <TextInput
              id="personalPhoneN"
              type="text"
              title={spanish ? 'Número telefónico*' : 'Phone number*'}
              value={userAddressInfo ? userAddressInfo.personalPhoneNumber : ''}
              placeholder={spanish ? '10 dígitos' : '10 digits'}
              onChange={addressFormChangeHandler}
              onKeyPress={numberChars}
              minLength={10}
              maxLength={10}
              required
            />
          </div>
        </div>
      </div>
      <div className={styles.fieldset}>
        <h4>{spanish ? ShippingInfoSpanish : ShippingInfoEnglish}</h4>
        <div className={styles.hidde}>
          <TextInput
            id="shippingName"
            type="text"
            title={spanish ? 'Nombre*' : 'Name*'}
            value={userAddressInfo ? userAddressInfo.shippingName : ''}
            onChange={addressFormChangeHandler}
            onKeyPress={textChars}
            required
          />
        </div>
        <div className={styles.hidde}>
          <TextInput
            id="shippingMiddleName"
            type="text"
            title={spanish ? 'segundo nombre' : 'Second name'}
            value={userAddressInfo ? userAddressInfo.shippingMiddleName : ''}
            placeholder={spanish ? 'opcional' : 'optional'}
            onChange={addressFormChangeHandler}
            onKeyPress={textChars}
          />
        </div>
        <div className={styles.hidde}>
          <TextInput
            id="shippingLastName"
            type="text"
            title={spanish ? 'Apellido*' : 'Last name*'}
            value={userAddressInfo ? userAddressInfo.shippingLastName : ''}
            onChange={addressFormChangeHandler}
            onKeyPress={textChars}
            required
          />
        </div>
        <div className={styles.hidde}>
          <TextInput
            id="shippingEmail"
            type="email"
            title={spanish ? 'Correo electrónico*' : 'Email*'}
            value={userAddressInfo ? userAddressInfo.shippingEmail : ''}
            onChange={addressFormChangeHandler}
            onKeyPress={emailChars}
            required
          />
        </div>
        <div className={styles.field}>
          <TextInput
            id="shippingAddressL1"
            type="text"
            title={spanish ? 'Dirección*' : 'Address*'}
            value={userAddressInfo ? userAddressInfo.shippingAddressL1 : ''}
            onChange={addressFormChangeHandler}
            onKeyPress={alphanumericChars}
            required
          />
        </div>
        <div className={styles.field}>
          <TextInput
            id="shippingAddressL2"
            type="text"
            title={spanish ? 'Referencias' : 'Address line 2'}
            value={userAddressInfo ? userAddressInfo.shippingAddressL2 : ''}
            placeholder={spanish ? 'opcional' : 'optional'}
            onChange={addressFormChangeHandler}
            onKeyPress={alphanumericChars}
          />
        </div>
        <div className={styles.field}>
          <TextInput
            id="shippingZipCode"
            type="text"
            title={spanish ? 'Código postal*' : 'Zip code*'}
            value={userAddressInfo ? userAddressInfo.shippingZipCode : ''}
            onChange={addressFormChangeHandler}
            onKeyPress={numberChars}
            minLength={5}
            maxLength={5}
            required
          />
        </div>
        <div className={styles.field}>
          <SuburbSelector
            id="shippingSuburb"
            title={spanish ? 'Colonia*' : 'Suburb*'}
            value={userAddressInfo ? userAddressInfo.shippingSuburb : ''}
            options={suburbOptions}
            placeholder={
              spanish ? 'Selecciona tu colonia*' : 'Select your suburb*'
            }
            onChange={addressFormChangeHandler}
            required
            disabled={!hasSuburbOptions}
          />
        </div>
        <div className={styles.field}>
          <TextInput
            id="shippingCity"
            title={spanish ? 'Ciudad*' : 'City*'}
            value={userAddressInfo ? userAddressInfo.cityValue : ''}
            placeholder={cityPlaceholder}
            onChange={addressFormChangeHandler}
            required
            disabled
          />
        </div>
        <div className={styles.field}>
          <TextInput
            id="shippingState"
            title={spanish ? 'Estado*' : 'State*'}
            value={userAddressInfo ? userAddressInfo.estadoValue : ''}
            placeholder={statePlaceholder}
            onChange={addressFormChangeHandler}
            required
            disabled
          />
        </div>
        <div className={styles.field}>
          <TextInput
            type="text"
            title={spanish ? 'País*' : 'Country*'}
            placeholder="México"
            disabled
          />
        </div>
        <div className={styles.fieldFull} />
        <div className={styles.hidde}>
          <p>{spanish ? 'Número telefónico*' : 'Phone number*'}</p>
          <div className={styles.fieldPhoneSelect}>
            <TelSelector
              id="shippingPhoneType"
              title={spanish ? 'Tipo*' : 'Type*'}
              value={shippingTelSelection || 'móvil'}
              placeholder={spanish ? 'Seleccionar' : 'Select'}
              options={spanish ? ['móvil', 'fijo'] : ['mobile', 'home']}
              onChange={addressFormChangeHandler}
              required
            />
          </div>
          <div className={styles.fieldPhoneText}>
            <TextInput
              id="shippingPhoneNumber"
              type="text"
              title={spanish ? 'Número*' : 'Number*'}
              value={userAddressInfo ? userAddressInfo.shippingPhoneNumber : ''}
              placeholder={spanish ? '10 dígitos' : '10 digits'}
              onChange={addressFormChangeHandler}
              onKeyPress={numberChars}
              minLength={10}
              maxLength={10}
              required
            />
          </div>
        </div>
      </div>
    </>
  );
};

const BillingRequired = ({
  required,
  content,
  billingInfo,
  toggleBilling,
  billingFormChangeHandler,
  regimensList,
  CFDIList,
}) => {
  const { BillingRequiredSpanish, BillingRequiredEnglish } = content;
  return (
    <div className={styles.fieldset}>
      <div className={styles.fieldRadio}>
        <Radio
          value1="No"
          value2={spanish ? 'Si' : 'Yes'}
          onChange={toggleBilling}
          type="checkbox"
          checked={required}
        >
          <p>{spanish ? BillingRequiredSpanish : BillingRequiredEnglish}</p>
        </Radio>
      </div>
      {required ? (
        <>
          <div className={styles.field}>
            <TextInput
              id="billingRFC"
              type="text"
              title="RFC*"
              onChange={billingFormChangeHandler}
              onKeyPress={alphanumericChars}
              value={billingInfo?.rfc ?? ''}
              minLength={12}
              maxLength={13}
            />
          </div>
          <div className={styles.field}>
            <TextInput
              id="billingName"
              type="text"
              title={
                spanish ? 'Nombre / Razón social*' : 'Name / Business name*'
              }
              onChange={billingFormChangeHandler}
              onKeyPress={textChars}
              value={billingInfo?.razon ?? ''}
            />
          </div>
          <div className={styles.field}>
            <Selector
              id="billingRegimen"
              type="text"
              title="Régimen*"
              placeholder="Seleccionar"
              fiscalRegimeOptions={regimensList}
              onChange={billingFormChangeHandler}
              value={billingInfo?.regimen ?? ''}
            />
          </div>
          <div className={styles.field}>
            <Selector
              id="billingCFDI"
              type="text"
              title="Uso CFDI*"
              placeholder="Seleccionar"
              cfdiOptions={CFDIList}
              onChange={billingFormChangeHandler}
              value={billingInfo?.cfdi ?? ''}
            />
          </div>
          <div className={styles.field}>
            <TextInput
              id="billingZipCode"
              type="text"
              title={spanish ? 'Código postal*' : 'Zip code*'}
              onChange={billingFormChangeHandler}
              onKeyPress={numberChars}
              minLength={5}
              maxLength={5}
              value={billingInfo?.billingZipCode ?? ''}
            />
          </div>
        </>
      ) : (
        ''
      )}
    </div>
  );
};

const Checkboxes = ({ setcheckboxPrivacy, setcheckboxTerms }) => (
  <div className={styles.checkboxes}>
    <Checkbox
      title={
        spanish
          ? 'He leído y acepto el Aviso de privacidad'
          : 'I have read and accept the Privacy policy'
      }
      link={spanish ? 'ver »' : 'read »'}
      url={spanish ? '/mex/es-mx/privacy' : '/mex/en-us/privacy'}
      validate={setcheckboxPrivacy}
    />
    <Checkbox
      title={
        spanish
          ? 'He leído y acepto los Términos y condiciones'
          : 'I have read and accept the Terms and conditions'
      }
      link={spanish ? 'ver »' : 'read »'}
      url={spanish ? '/mex/es-mx/terms' : '/mex/en-us/terms'}
      validate={setcheckboxTerms}
    />
  </div>
);

const Bottom = ({ content, onSubmitForm, disabled }) => {
  const { ContinueButtonSpanish, ContinueButtonEnglish } = content;
  return (
    <div className={styles.button}>
      <button
        type="button"
        className={`btn btn-yellow ${disabled ? 'disabled' : ''}`}
        onClick={onSubmitForm}
        disabled={disabled}
      >
        {spanish ? ContinueButtonSpanish : ContinueButtonEnglish}
      </button>
    </div>
  );
};

const Address = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [content, setContent] = useState(false);
  const [billingRequired, setBillingrequired] = useState(false);
  const [billingValidation, setbillingValidation] = useState(false);
  const [shippingInfo, setShippingInfo] = useState(null);
  const [billingInfo, setBillingInfo] = useState(null);
  const [addressInfo, setAddressInfo] = useState([]);
  const [cityValue, setCityValue] = useState('');
  const [stateValue, setStateValue] = useState('');
  const [idCity, setIdCity] = useState(null);
  const [idState, setIdState] = useState(null);
  const [idSuburb, setIdSuburb] = useState(null);
  const [suburbName, setSuburbName] = useState(null);
  const [suburbOptions, setSuburbOptions] = useState([]);
  const cartId = useSelector((globalState) => globalState.cartInfo.IdCarrito);
  const addressId = useSelector(
    (globalState) => globalState.shippingInfo.addressId
  );
  const toggleBilling = () => setBillingrequired(!billingRequired);
  const [regimensList, setRegimensList] = useState([]);
  const [CFDIList, setCFDIList] = useState([]);

  const [allFieldsCompleted, setallFieldsCompleted] = useState(false);
  const [checkboxPrivacy, setcheckboxPrivacy] = useState(false);
  const [checkboxTerms, setcheckboxTerms] = useState(false);
  const checkboxesChecked = checkboxPrivacy && checkboxTerms;
  const hasSuburbOptions = suburbOptions.length > 0;
  const isDisabled =
    !allFieldsCompleted ||
    !hasSuburbOptions ||
    !checkboxesChecked ||
    (billingRequired && !billingValidation);
  const [open, setOpen] = useState(false);
  const [emailValidate, setEmailValidate] = useState(null);
  const [codeEmail, setCodeEmail] = useState(null);
  const [stateError, setStateError] = useState(null);

  const getAddressInfo = async (zipCode) => {
    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
      CodigoPostal: zipCode,
    };

    try {
      const resp = await ApiAddress.getAddresInfoByZipCode(payload);
      if (resp.Codigo === 200) {
        setAddressInfo(resp.InfoDireccion);
        const suburbs = [];
        resp.InfoDireccion.map((item) =>
          suburbs.push({ IdColonia: item.IdColonia, Colonia: item.Colonia })
        );
        setSuburbOptions(suburbs);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getUserAddressInfo = async () => {
    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
      IdDireccion: addressId,
    };

    const resp = await ApiAddress.getUserAddressInfo(payload);
    if (resp.Codigo === 200) {
      const shippingInfoObj = { ...shippingInfo };
      shippingInfoObj.personalName = resp.InfoEnvio[0].Nombre_P;
      shippingInfoObj.personalMiddleName = resp.InfoEnvio[0].Segundo_Nombre_P;
      shippingInfoObj.personalLastName = resp.InfoEnvio[0].Apellidos_P;
      shippingInfoObj.personalEmail = resp.InfoEnvio[0].Email_P;
      shippingInfoObj.personalPhoneType = resp.InfoEnvio[0].Tipo_Tel_P;
      shippingInfoObj.personalPhoneNumber = resp.InfoEnvio[0].Numero_Tel_P;
      shippingInfoObj.shippingName = resp.InfoEnvio[0].Nombre_E;
      shippingInfoObj.shippingMiddleName = resp.InfoEnvio[0].Segundo_Nombre_E;
      shippingInfoObj.shippingLastName = resp.InfoEnvio[0].Apellidos_E;
      shippingInfoObj.shippingEmail = resp.InfoEnvio[0].Email_E;
      shippingInfoObj.shippingAddressL1 = resp.InfoEnvio[0].Direccion_Linea_1;
      shippingInfoObj.shippingAddressL2 = resp.InfoEnvio[0].Direccion_Linea_2;
      shippingInfoObj.IdEstado = resp.InfoEnvio[0].IdEstado;
      shippingInfoObj.shippingSuburb = resp.InfoEnvio[0].IdColonia;
      const selectedSuburb = addressInfo?.find(
        (item) => item.IdColonia === resp.InfoEnvio[0].IdColonia
      );
      shippingInfoObj.estadoValue = selectedSuburb?.Estado;
      shippingInfoObj.cityValue = selectedSuburb?.Municipio;
      setCityValue(selectedSuburb?.Municipio);
      setIdCity(resp.InfoEnvio[0].IdCiudad);
      setStateValue(selectedSuburb?.Estado);
      setIdState(resp.InfoEnvio[0].IdEstado);
      setIdSuburb(resp.InfoEnvio[0].IdColonia);
      setSuburbName(selectedSuburb?.Colonia);
      shippingInfoObj.shippingCity = resp.InfoEnvio[0].IdCiudad;
      shippingInfoObj.shippingZipCode = resp.InfoEnvio[0].Codigo_Postal;
      getAddressInfo(resp.InfoEnvio[0].Codigo_Postal);
      shippingInfoObj.shippingPhoneType = resp.InfoEnvio[0].Tipo_Tel_E;
      shippingInfoObj.shippingPhoneNumber = resp.InfoEnvio[0].Numero_Tel_E;

      setShippingInfo(shippingInfoObj);
    }
  };

  const getCfdiList = async (idRegimen) => {
    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
      IdRegimen: idRegimen,
    };
    const resp = await ApiBilling.getCfdiList(payload);
    if (resp.Codigo === 200) {
      setCFDIList(resp.Lista);
    }
  };

  const getFiscalRegimes = async () => {
    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
    };
    const resp = await ApiBilling.getFiscalRegimes(payload);
    if (resp.Codigo === 200) {
      setRegimensList(resp.Lista);
    }
  };

  const addressFormChangeHandler = (e) => {
    const shippingInfoObj = { ...shippingInfo };
    // console.log(e.target.id, e.target.value);
    switch (e.target.id) {
      case 'personalName':
        shippingInfoObj.personalName = e.target.value;
        shippingInfoObj.shippingName = e.target.value;
        break;
      case 'personalMiddleName':
        shippingInfoObj.personalMiddleName = e.target.value;
        shippingInfoObj.shippingMiddleName = e.target.value;
        break;
      case 'personalLastName':
        shippingInfoObj.personalLastName = e.target.value;
        shippingInfoObj.shippingLastName = e.target.value;
        break;
      case 'personalEmail':
        shippingInfoObj.personalEmail = e.target.value;
        shippingInfoObj.shippingEmail = e.target.value;
        break;
      case 'personalPhoneType':
        shippingInfoObj.personalPhoneType = e.target.value === 'móvil' ? 1 : 2;
        shippingInfoObj.shippingPhoneType = e.target.value === 'móvil' ? 1 : 2;
        break;
      case 'personalPhoneN':
        shippingInfoObj.personalPhoneNumber = e.target.value;
        shippingInfoObj.shippingPhoneNumber = e.target.value;
        break;
      case 'shippingName':
        shippingInfoObj.shippingName = e.target.value;
        break;
      case 'shippingMiddleName':
        shippingInfoObj.shippingMiddleName = e.target.value;
        break;
      case 'shippingLastName':
        shippingInfoObj.shippingLastName = e.target.value;
        break;
      case 'shippingEmail':
        shippingInfoObj.shippingEmail = e.target.value;
        break;
      case 'shippingAddressL1':
        shippingInfoObj.shippingAddressL1 = e.target.value;
        break;
      case 'shippingState':
        shippingInfoObj.IdEstado = e.target.value;
        break;
      case 'shippingAddressL2':
        shippingInfoObj.shippingAddressL2 = e.target.value;
        break;
      case 'shippingSuburb': {
        shippingInfoObj.shippingSuburb = e.target.value;
        const selectedSuburb = addressInfo.find(
          (item) => item.IdColonia.toString() === e.target.value
        );
        shippingInfoObj.estadoValue = selectedSuburb?.Estado;
        shippingInfoObj.cityValue = selectedSuburb?.Municipio;
        shippingInfoObj.cityStr = selectedSuburb.Municipio;
        shippingInfoObj.suburbStr = selectedSuburb.Colonia;
        shippingInfoObj.stateStr = selectedSuburb.Estado;

        setCityValue(selectedSuburb?.Municipio);
        setIdCity(selectedSuburb?.IdMunicpio);
        setStateValue(selectedSuburb?.Estado);
        setIdState(selectedSuburb?.IdEstado);
        setIdSuburb(selectedSuburb?.IdColonia);
        setSuburbName(selectedSuburb?.Colonia);
        setShippingInfo(shippingInfoObj);
        break;
      }
      case 'shippingCity':
        shippingInfoObj.shippingCity = e.target.value;
        break;
      case 'shippingZipCode':
        shippingInfoObj.shippingZipCode = e.target.value;
        if (shippingInfoObj.shippingZipCode.length === 5) {
          getAddressInfo(e.target.value);
        }
        break;
      case 'shippingPhoneType':
        shippingInfoObj.shippingPhoneType = e.target.value === 'móvil' ? 1 : 2;
        break;
      case 'shippingPhoneNumber':
        shippingInfoObj.shippingPhoneNumber = e.target.value;
        break;
      default:
        console.log('');
        break;
    }
    setShippingInfo(shippingInfoObj);
    const requiredFields = [
      shippingInfoObj.personalName,
      shippingInfoObj.personalLastName,
      shippingInfoObj.personalEmail,
      shippingInfoObj.personalPhoneNumber,
      shippingInfoObj.shippingName,
      shippingInfoObj.shippingLastName,
      shippingInfoObj.shippingEmail,
      shippingInfoObj.shippingAddressL1,
      shippingInfoObj.shippingZipCode,
      shippingInfoObj.shippingSuburb,
      shippingInfoObj.cityValue,
      shippingInfoObj.estadoValue,
      shippingInfoObj.shippingPhoneNumber,
    ];
    const valFieldsCompleted = requiredFields.every(
      (field) => field !== undefined && field !== ''
    );
    setallFieldsCompleted(valFieldsCompleted);
  };

  const billingFormChangeHandler = (e) => {
    const billingInfoObj = { ...billingInfo };
    switch (e.target.id) {
      case 'billingRFC':
        billingInfoObj.rfc = e.target.value;
        break;
      case 'billingName':
        billingInfoObj.razon = e.target.value;
        break;
      case 'billingRegimen':
        billingInfoObj.regimen = e.target.value;
        getCfdiList(e.target.value);
        break;
      case 'billingCFDI':
        billingInfoObj.cfdi = e.target.value;
        break;
      case 'billingZipCode':
        billingInfoObj.billingZipCode = e.target.value;
        // setBillingZipCode(true);
        break;
      default:
        console.log('');
        break;
    }

    setBillingInfo(billingInfoObj);
    setbillingValidation(
      billingInfoObj.rfc !== undefined &&
        billingInfoObj.rfc !== '' &&
        billingInfoObj.razon !== undefined &&
        billingInfoObj.razon !== '' &&
        billingInfoObj.billingZipCode !== undefined &&
        billingInfoObj.billingZipCode !== '' &&
        billingInfoObj.regimen !== undefined &&
        billingInfoObj.regimen !== '' &&
        billingInfoObj.cfdi !== undefined &&
        billingInfoObj.cfdi !== ''
    );
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onChangeCode = (e) => {
    setCodeEmail(e.target.value);
  };

  const onCheckCode = async () => {
    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
      IdCarrito: cartId,
      Token: codeEmail,
    };
    const resp = await ValidateEmail.validateToken(payload);
    if (resp.Codigo === 200 || Config.api_services.environment === 'TEST')
      history.push('/mex/es-mx/checkout/shipping');
    if (resp.Codigo !== 200) setStateError(resp.Mensaje);
  };

  const onSubmitForm = async () => {
    shippingInfo.reqFac = billingRequired;
    let payloadBilling = {};
    const payloadValEmail = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
      IdCarrito: cartId,
    };
    const payloadShipping = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
      InfoEnvio: {
        FormaVenta: 3,
        IdCarrito: cartId,
        IdFbo: 0,
        Nombre_P: shippingInfo.personalName,
        Segundo_Nombre_P: shippingInfo.personalMiddleName,
        Apellidos_P: shippingInfo.personalLastName,
        Email_P: shippingInfo.personalEmail,
        Tipo_Tel_P: shippingInfo.personalPhoneType,
        Numero_Tel_P: shippingInfo.personalPhoneNumber,
        Nombre_E: shippingInfo.shippingName,
        Segundo_Nombre_E: shippingInfo.shippingMiddleName,
        Apellidos_E: shippingInfo.shippingLastName,
        Direccion_Linea_1: shippingInfo.shippingAddressL1,
        Direccion_Linea_2: shippingInfo.shippingAddressL2,
        IdColonia: idSuburb,
        Colonia: suburbName,
        IdCiudad: idCity,
        Ciudad: cityValue,
        IdEstado: idState,
        Codigo_Postal: shippingInfo.shippingZipCode,
        Email_E: shippingInfo.shippingEmail,
        Tipo_Tel_E: shippingInfo.shippingPhoneType,
        Numero_Tel_E: shippingInfo.shippingPhoneNumber,
      },
    };

    if (billingRequired) {
      payloadBilling = {
        Cliente: Config.api_services.client,
        Pais: 'MEX',
        Ambiente: Config.api_services.environment,
        InfoFacturacion: {
          IdCarrito: cartId,
          fiscal_RFC: billingInfo.rfc,
          fiscal_Nombre: `${shippingInfo.personalName} ${
            shippingInfo.personalMiddleName
              ? shippingInfo.personalMiddleName
              : ''
          } ${shippingInfo.personalLastName}`,
          fiscal_idUsoCFDI: billingInfo.cfdi,
          fiscal_Codigo_Postal: billingInfo.billingZipCode,
        },
      };
    }

    shippingInfo.factData = billingInfo;
    const resp = await ApiShipping.sendShippingInfo(payloadShipping);
    if (resp.Codigo === 200) {
      dispatch(
        setShippingAddress(
          resp.Confirmacion[0].IdDireccion,
          shippingInfo.personalName,
          shippingInfo.personalMiddleName,
          shippingInfo.personalLastName,
          shippingInfo.personalEmail,
          shippingInfo.personalPhoneType,
          shippingInfo.personalPhoneNumber,
          shippingInfo.shippingName,
          shippingInfo.shippingMiddleName,
          shippingInfo.shippingLastName,
          shippingInfo.shippingEmail,
          shippingInfo.shippingAddressL1,
          shippingInfo.shippingAddressL2,
          suburbName,
          stateValue,
          idState,
          shippingInfo.shippingZipCode,
          shippingInfo.shippingPhoneType,
          shippingInfo.shippingPhoneNumber,
          shippingInfo.reqFac,
          shippingInfo.factData
        )
      );
      if (billingRequired) {
        await ApiBilling.setBillingAddress(payloadBilling);
        /* if (respBilling.Codigo === 200) {
          history.push('/mex/es-mx/checkout/shipping');
        } */
      } else {
        // history.push('/mex/es-mx/checkout/shipping');
      }
      const respEmail = await ValidateEmail.sendEmail(payloadValEmail);
      if (respEmail.Codigo === 200) {
        setEmailValidate(respEmail.Email);
        handleOpen();
      }
    }
  };

  useEffect(async () => {
    setContent(await apiShippingCMS.getContent());
    getFiscalRegimes();
    if (addressId) {
      getUserAddressInfo();
    }
  }, []);
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <ModalEmail
          open={open}
          handleClose={handleClose}
          email={emailValidate}
          onChangeCode={onChangeCode}
          onCheckCode={onCheckCode}
          error={stateError}
        />
        <form className={styles.form}>
          <div className={styles.formContent}>
            <AddressForm
              userAddressInfo={shippingInfo}
              content={content}
              addressInfo={addressInfo}
              suburbOptions={suburbOptions}
              cityValue={cityValue}
              stateValue={stateValue}
              addressFormChangeHandler={addressFormChangeHandler}
            />
            <BillingRequired
              required={billingRequired}
              toggleBilling={toggleBilling}
              content={content}
              billingInfo={billingInfo}
              billingFormChangeHandler={billingFormChangeHandler}
              regimensList={regimensList}
              CFDIList={CFDIList}
            />
          </div>
          <Checkboxes
            content={content}
            setcheckboxPrivacy={setcheckboxPrivacy}
            setcheckboxTerms={setcheckboxTerms}
          />
          <Bottom
            content={content}
            onSubmitForm={onSubmitForm}
            disabled={isDisabled}
          />
        </form>
      </div>
    </div>
  );
};

export default Address;
